import { render, staticRenderFns } from "./UpadateModal.vue?vue&type=template&id=f0cadafc&scoped=true&"
import script from "./UpadateModal.vue?vue&type=script&lang=js&"
export * from "./UpadateModal.vue?vue&type=script&lang=js&"
import style0 from "./UpadateModal.vue?vue&type=style&index=0&id=f0cadafc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cadafc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VSelect})
